import { h } from '@atomify/jsx';
import { StatusColor } from '@source/utilities/api-formatters';

export interface LabelProps {
    classes?: string;
    color?: string; // Color class
    formattedStatusColor?: StatusColor; // FormattedStatusColor
    text: string | Text;
    highlighted?: boolean;
}

const formattedStatusColorClass: { [key in StatusColor]: string } = {
    green: 'label--positive',
    orange: 'label--attention',
    grey: '',
    purple: 'label--progression',
    red: 'label--urgent',
};

const Label = (data: LabelProps) => {
    let color = data.color ? `label--${data.color}` : '';

    if (data.formattedStatusColor) {
        color = formattedStatusColorClass[data.formattedStatusColor];
    }

    let className = 'c-label';
    className += ` ${color}`;
    if (data.classes) className += ` ${data.classes}`;
    if (data.highlighted) className += ` is-highlighted`;

    return <span class={className}>{data.text}</span>;
};

export { Label };
